export default __webpack_public_path__ + "static/audio-cardio-5-e-39e1ccfbb00d4172626b12992ca5fdf0.webp";